var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSeo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#seo_svg__clip0)",
    fill: "#F2F2F2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.5 45c-8.273 0-15-6.727-15-15s6.727-15 15-15 15 6.727 15 15-6.727 15-15 15zm0-27.5C30.608 17.5 25 23.108 25 30s5.608 12.5 12.5 12.5S50 36.892 50 30s-5.608-12.5-12.5-12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.75 52.5c-.32 0-.64-.123-.885-.365l-11.54-11.54a1.25 1.25 0 011.767-1.767l11.54 11.54a1.25 1.25 0 01-.882 2.132zM43.75 5H1.25a1.25 1.25 0 010-2.5h42.5a1.25 1.25 0 010 2.5zM43.75 57.5H1.25a1.25 1.25 0 010-2.5h42.5a1.25 1.25 0 010 2.5zM21.25 17.5h-20a1.25 1.25 0 010-2.5h20a1.25 1.25 0 010 2.5zM21.25 45h-20a1.25 1.25 0 010-2.5h20a1.25 1.25 0 010 2.5zM16.25 31.25h-15a1.25 1.25 0 010-2.5h15a1.25 1.25 0 010 2.5z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "seo_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v60H0z"
  })))));
}

export default SvgSeo;